export class WorklistMessages extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.enabled_alert_id = this.dataset.enabled_alert_id;
        this.message_id = this.dataset.message_id;
        setTimeout(() => {
            this.showExtraMessages();
            this.initEventListeners();
        }, 100);
    }

    showExtraMessages() {
        const enabledCheckbox = this.querySelector('input[name="enabled"][value="1"]');
        const isAlertCheckbox = this.querySelector('input[name="is_alert"][value="1"]');
        const enabledLabel = this.querySelector('label[for="enabled"]');
        if (enabledLabel) {
            const enabledButtons = enabledLabel.nextElementSibling;
            if (enabledButtons) {
                enabledButtons.style.display = "flex";
                enabledButtons.style.alignItems = "center";
                let enabledMsg = enabledButtons.querySelector("span.enabled_msg");
                if (!enabledMsg) {
                    enabledMsg = document.createElement("span");
                    enabledMsg.className = "enabled_msg";
                    enabledButtons.appendChild(enabledMsg);
                }
                const textContent = this.getEnabledCheckboxText();
                if (textContent.includes("<span")) {
                    enabledMsg.innerHTML = textContent; // Use innerHTML to allow HTML content
                } else {
                    enabledMsg.textContent = textContent;
                }
            }
        }
    }

    getEnabledCheckboxText()
    {
        const enabledCheckbox = this.querySelector('input[name="enabled"][value="1"]');
        const isAlertCheckbox = this.querySelector('input[name="is_alert"][value="1"]');

        if (this.enabled_alert_id) {
            // One of the alert messages is enabled
            if (isAlertCheckbox.checked) {
                if (enabledCheckbox.checked && this.message_id == this.enabled_alert_id) {
                    return "<span style='color: #d35b6c;'>WORKLIST IS CURRENTLY DISPLAYING THIS ALERT MESSAGE</span>";
                } else {
                    return "Only one alert message can be enabled at a time.";
                }
            } else {
                if (enabledCheckbox.checked) {
                    return "This message is currently not displayed while an alert message is enabled.";
                } else {
                    return "Non-alert messages will not be displayed when an alert message is enabled.";
                }
            } 
        } else {
            if (isAlertCheckbox.checked) {
                if (enabledCheckbox.checked) {
                    return "<span style='color: #d35b6c;'>WORKLIST IS CURRENTLY DISPLAYING THIS ALERT MESSAGE</span>";
                } else {
                    return "Enabling this message will disable all other messages.";
                }
            } else {
                if (enabledCheckbox.checked) {
                    return "This message is currently being displayed with other non-alert messages.";
                } else {
                    return "This message is currently not displayed.";
                }
            }
        }
    }

    initEventListeners() {
        const radios = this.querySelectorAll('input[type="radio"]');
        radios.forEach(radio => {
            radio.closest('label').addEventListener("click", (event) => {
                const enabledCheckbox = this.querySelector('input[name="enabled"][value="1"]');
                const isAlertCheckbox = this.querySelector('input[name="is_alert"][value="1"]');
                const btnGroup = radio.closest('.btn-group');

                if (btnGroup && btnGroup.querySelector('input[name = "is_alert"]')) {
                    if (enabledCheckbox.checked && !isAlertCheckbox.checked && this.enabled_alert_id && this.enabled_alert_id != this.message_id) {
                        event.preventDefault();
                        event.stopPropagation();
                        return false;
                    }
                } else {
                    if (isAlertCheckbox.checked && !enabledCheckbox.checked && this.enabled_alert_id && this.enabled_alert_id != this.message_id) {
                        event.preventDefault();
                        event.stopPropagation();
                        return false;
                    }
                }

                setTimeout(() => {  
                    this.showExtraMessages();
                }, 100);
            });
        });
    }
}

customElements.define("worklist-messages", WorklistMessages);
